<template>

  <div id="wrapper">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li>
                <router-link :to="{name: 'Dashboard'}">Dashboard</router-link>
              </li>
              <li class="active">
                <span>Profile</span>
              </li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs">
            Profile
          </h3>
          <small>Manage personal information, email and notification settings, quotas and bills</small>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="row">
        <div class="col-lg-4">
          <overview :user="user" v-if="user"></overview>
        </div>
        <div class="col-lg-8">
          <div class="hpanel">
            <div class="hpanel">

              <ul class="nav nav-tabs">
                <li class="active"><a data-toggle="tab" href="#personal-info-tab">Personal Info</a></li>
                <!--                <li class=""><a data-toggle="tab" href="#tab-2">Email & Notifications Settings</a></li>-->
                <li class=""><a data-toggle="tab" href="#company-tab">Organisation Info</a></li>
                <li class=""><a data-toggle="tab" href="#tab-3">Plan & Quotas</a></li>
                <li class=""><a data-toggle="tab" href="#tab-4">Bills</a></li>
                <li class=""><a data-toggle="tab" href="#password-tab">Password</a></li>
              </ul>
              <div class="tab-content">
                <div id="personal-info-tab" class="tab-pane active">
                  <profile-personal-information v-model="user" v-if="user"></profile-personal-information>
                </div>
                <div id="company-tab" class="tab-pane">
                  <company-information-v2 :company="user.company" :userId="user.id" v-if="user" v-model="user.company"></company-information-v2>
                </div>
                <!--                <div id="tab-2" class="tab-pane">-->
                <!--                  <email-notification-settings v-model="user"></email-notification-settings>-->
                <!--                </div>-->
                <div id="tab-3" class="tab-pane">
                  <quota v-if="user" :planCredit="user.plan_credit"></quota>
                </div>
                <div id="tab-4" class="tab-pane">
                  <bills></bills>
                </div>
                <div id="password-tab" class="tab-pane">
                  <update-password v-if="user" :userId="user.id"></update-password>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import VueLadda from 'vue-ladda'
import Summernote from '../../components/utils/Summernote'
import Overview from '../../components/user/Overview'
import ProfilePersonalInformation from '../../components/user/ProfilePersonalInformation'
import EmailNotificationSettings from '../../components/user/EmailNotificationSettings'
import Quota from '../../components/user/Quota'
import Bills from '../../components/user/Bills'
import UpdatePassword from '../../components/user/UpdatePassword'
import CompanyInformationV2 from '../../components/user/CompanyInformationV2'

export default {
  components: {
    ProfilePersonalInformation,
    UpdatePassword,
    Bills,
    CompanyInformationV2,
    Quota,
    EmailNotificationSettings,
    Overview,
    Summernote,
    VueLadda
  },
  name: 'ProfilePreview',
  props: [],
  data () {
    return {
      user: null
    }
  },
  methods: {
    getResources: function () {
      this.axios.get('user/' + this.$auth.user().id + '?relations={planCredit,planCredit.plan,expert,expert.keywords.keyword}').then((response) => {
        this.user = response.data
      })
    }
  },
  beforeMount () {
    this.getResources()
    this.$eventHub.$on('refreshProfile', (item) => {
      this.getResources()
    })
  },
  beforeDestroy () {
    this.$eventHub.$off('refreshProfile')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/ProfilePreview.vue